// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --black: #000;
    --white: #fff;
    --green: #3a7a10;
    --gray-font: #4c4c4c;
    --gray-heading: #1d1d1d;
    --light-gray: #b2b2b2;
    --gray-header-background: #f5f7f9;
    --light-green-background: rgba(58, 122, 16, 0.14);
    --red-error: #cc3300;
}
`, "",{"version":3,"sources":["webpack://./src/variables.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,aAAa;IACb,gBAAgB;IAChB,oBAAoB;IACpB,uBAAuB;IACvB,qBAAqB;IACrB,iCAAiC;IACjC,iDAAiD;IACjD,oBAAoB;AACxB","sourcesContent":[":root {\n    --black: #000;\n    --white: #fff;\n    --green: #3a7a10;\n    --gray-font: #4c4c4c;\n    --gray-heading: #1d1d1d;\n    --light-gray: #b2b2b2;\n    --gray-header-background: #f5f7f9;\n    --light-green-background: rgba(58, 122, 16, 0.14);\n    --red-error: #cc3300;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
